import styled, { css } from 'styled-components';

import { Button } from 'libs/ui';

export const AddButton = styled(Button)`
  margin: 20px 0 0;
`;

export const Content = styled.ul`
  li {
    list-style-type: none;
  }
`;

export const InputsPlace = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  img {
    cursor: pointer;
    margin-left: 12px;
  }
`;

export const FieldPlace = styled.div`
  width: ${(props) => props.w}px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: right;
  padding: 10px;
  ${(props) =>
    props.$center &&
    css`
      justify-content: center;
    `}
  input {
    width: ${(props) => (props.wide ? '90%' : '100%')};
    height: 100%;
    border: none;
    background-color: inherit;
    outline: none;
    color: ${(props) => (props.error ? '#d33d34' : '#fff')};
    font-size: 15px;
    text-align: end;
    //margin-right: 10px;
    color-scheme: dark;
  }
  input[type='radio'] {
    appearance: none;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    border: 1px solid #999;
    transition: 0.2s all linear;
    position: relative;
    top: 2px;
    cursor: pointer;
    &:checked {
      background-color: #ccc;
    }
  }
  span {
    display: block;
    margin-left: 7px;
    opacity: 0.7;
    color: ${(props) => (props.error ? '#d33d34' : '#fff')};
    font-size: 15px;
  }
  &.with-border {
    border: 1px solid #9195a6;
    border-radius: 4px;
    height: auto;
    padding: 5px 10px;
  }
`;
